<template>
  <div class="col-12 sector payment-sector px-3">
    <div class="row">
      <div class="sector__header">
        {{ t("orders.paymentMethod") }}
      </div>
      <div class="sector__content">
        <div class="row">
          <el-radio-group v-model="form.payment_type" size="large" class="w-100 row m-0 justify-content-center">
            <el-radio
              v-for="payment in availablePaymentTypes"
              :key="payment.type"
              :label="payment.type"
              border
              class="col-12 col-sm-3 mb-2 mx-1"
              :disabled="chkLogisticType(payment.type)"
              :style="{ minHeight: '5rem', margin: '0 0rem 0 0' }"
            >
              {{ payment?.name }}
              <div class="text-black-50">{{ payment?.description }}</div>
            </el-radio>
          </el-radio-group>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel, useVModels } from '@vueuse/core'

const props = defineProps({
  modelValue: Object,
  availablePaymentTypes: { type: Array, default: () => []},
  chkLogistic: { type: Boolean, default: false},
})
const emit = defineEmits(['update:modelValue'])

const { t, locale } = useI18n()
const form = useVModel(props, 'modelValue', emit)

const changeOtherPayment = (paymentType) => {
  // 不支援的物流，預先變更金流方式
  if (form.value.payment_type == paymentType) {
    const availablePaymentTypes = props.availablePaymentTypes.filter((el) => el.type != paymentType)
    if (availablePaymentTypes.length) {
      form.value.payment_type = availablePaymentTypes[0].type
    }
  }
  return true
}

const chkLogisticType = (paymentType) => {
  // 需要檢查物流
  if (props.chkLogistic) {
    // console.log("chkLogisticType: ", form.value.logistic_type, paymentType)
    if (paymentType == "C2CUNIMART.COD" && !(['C2CUNIMART'].includes(form.value.logistic_type))) {
      return changeOtherPayment(paymentType)
    } else if (paymentType == "C2CFAMI.COD" && !(['C2CFAMI'].includes(form.value.logistic_type))) {
      return changeOtherPayment(paymentType)
    } else if (paymentType == "C2CHILIFE.COD" && !(['C2CHILIFE'].includes(form.value.logistic_type))) {
      return changeOtherPayment(paymentType)
    } else if (paymentType == "TCAT.COD" && !(['TCAT'].includes(form.value.logistic_type))) {
      return changeOtherPayment(paymentType)
    }
  }
  return false
}
</script>
